import React from 'react';
import { t } from 'i18next';

type FilterIconProps = {
  color?: string;
};

export default (props: FilterIconProps) => (
  <span title="Search Filters">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={t('altText.searchFilterButton')}
      role="img"
    >
      <path
        d="M3.47962 19.8465C3.23805 19.8465 3.04199 19.6505 3.04199 19.4089V12.2133C3.04199 11.9717 3.23805 11.7756 3.47962 11.7756C3.72119 11.7756 3.91724 11.9717 3.91724 12.2133V19.4089C3.91724 19.6505 3.7214 19.8465 3.47962 19.8465Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M16.5187 13.1415C16.2771 13.1415 16.0811 12.9454 16.0811 12.7039V0.591067C16.0811 0.349498 16.2771 0.153442 16.5187 0.153442C16.7602 0.153442 16.9563 0.349498 16.9563 0.591067V12.7039C16.9563 12.9457 16.7602 13.1415 16.5187 13.1415Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M9.99915 19.8465C9.75758 19.8465 9.56152 19.6505 9.56152 19.4089V6.26306C9.56152 6.0215 9.75758 5.82544 9.99915 5.82544C10.2407 5.82544 10.4368 6.0215 10.4368 6.26306V19.4089C10.4368 19.6505 10.2407 19.8465 9.99915 19.8465Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M9.99949 6.70076C8.8039 6.70076 7.83105 5.72813 7.83105 4.53232C7.83105 3.33651 8.80368 2.36389 9.99949 2.36389C11.1953 2.36389 12.1679 3.33651 12.1679 4.53232C12.1679 5.72813 11.1953 6.70076 9.99949 6.70076ZM9.99949 3.23936C9.28638 3.23936 8.7063 3.81943 8.7063 4.53254C8.7063 5.24565 9.28638 5.82572 9.99949 5.82572C10.7126 5.82572 11.2927 5.24565 11.2927 4.53254C11.2927 3.81943 10.7126 3.23936 9.99949 3.23936Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M3.47996 12.6509C2.28436 12.6509 1.31152 11.6783 1.31152 10.4825C1.31152 9.28693 2.28415 8.31409 3.47996 8.31409C4.67577 8.31409 5.64839 9.28671 5.64839 10.4825C5.64839 11.6783 4.67555 12.6509 3.47996 12.6509ZM3.47996 9.18934C2.76685 9.18934 2.18677 9.76941 2.18677 10.4825C2.18677 11.1956 2.76685 11.7757 3.47996 11.7757C4.19307 11.7757 4.77314 11.1956 4.77314 10.4825C4.77314 9.76941 4.19307 9.18934 3.47996 9.18934Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M16.5188 16.6031C15.3232 16.6031 14.3506 15.6305 14.3506 14.4347C14.3506 13.2391 15.3232 12.2665 16.5188 12.2665C17.7146 12.2665 18.6872 13.2391 18.6872 14.4347C18.6872 15.6303 17.7146 16.6031 16.5188 16.6031ZM16.5188 13.1415C15.8057 13.1415 15.2258 13.7214 15.2258 14.4345C15.2258 15.1476 15.8057 15.7276 16.5188 15.7276C17.2319 15.7276 17.812 15.1476 17.812 14.4345C17.812 13.7214 17.2319 13.1415 16.5188 13.1415Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M3.47962 9.1893C3.23805 9.1893 3.04199 8.99325 3.04199 8.75168V0.591067C3.04199 0.349498 3.23805 0.153442 3.47962 0.153442C3.72119 0.153442 3.91724 0.349498 3.91724 0.591067V8.75168C3.91724 8.99347 3.7214 9.1893 3.47962 9.1893Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M9.99915 3.23936C9.75758 3.23936 9.56152 3.0433 9.56152 2.80173V0.591067C9.56152 0.349498 9.75758 0.153442 9.99915 0.153442C10.2407 0.153442 10.4368 0.349498 10.4368 0.591067V2.80173C10.4368 3.0433 10.2407 3.23936 9.99915 3.23936Z"
        fill={props.color || '#27A4CC'}
      />
      <path
        d="M16.5187 19.8466C16.2771 19.8466 16.0811 19.6506 16.0811 19.409V16.1655C16.0811 15.924 16.2771 15.7279 16.5187 15.7279C16.7602 15.7279 16.9563 15.924 16.9563 16.1655V19.409C16.9563 19.6506 16.7602 19.8466 16.5187 19.8466Z"
        fill={props.color || '#27A4CC'}
      />
    </svg>
  </span>
);
